import { MenuItem } from '@mui/material'
import { Select } from '@weberlo/components'

import { StatsType } from 'types'

const selectOptions = [
  { name: 'Visitors', value: 'views' },
  { name: 'Forms', value: 'form_submits' },
  { name: 'Leads', value: 'leads' },
  { name: 'Orders', value: 'total_orders' },
  { name: 'Sales', value: 'total_amount' },
  { name: 'Sales (Initial)', value: 'orders_amount' },
  { name: 'Sales (Recurring)', value: 'recurring_payments_amount' },
]

/** Match DateRangePicker / toolbar controls: 32px tall, same typography */
const statsSelectSx = {
  mr: 1,
  '& .MuiInputBase-root': {
    height: 32,
    minHeight: 32,
    maxHeight: 32,
    width: 'auto',
    borderRadius: 2,
    fontSize: '0.8125rem',
    fontWeight: 500,
    boxSizing: 'border-box',
  },
  '& .MuiSelect-select': {
    py: '0 !important',
    pl: '12px !important',
    pr: '28px !important',
    minHeight: '32px !important',
    maxHeight: 32,
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.2,
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.light',
  },
  '& .MuiSelect-icon': {
    fontSize: 18,
    right: 6,
  },
}

const StatsSelect = ({ statsType, setStatsType }: Props) => {
  return (
    <Select
      size="small"
      sx={statsSelectSx}
      value={statsType}
      onChange={e => setStatsType(e.target.value as StatsType)}
      name="match">
      {selectOptions.map((option, index) => (
        <MenuItem
          key={index}
          value={option.value}>
          {option.name}
        </MenuItem>
      ))}
    </Select>
  )
}

interface Props {
  statsType: StatsType
  setStatsType: (type: StatsType) => void
}

export default StatsSelect
